"use client";

export { default as RecognitionBanner } from "@stadium/shared/src/components/recognition-banner";